export default __webpack_public_path__ + "static/media/red-arrow-left.addaf135.svg";